<template lang="pug">
app-page(:fab-items="fabItems" title="Шаблоны запросов")
    app-toolbar(title="Список организаций")
      app-toolbar-item(v-if="isCategoriesLoaded" label="Категория" all="Все" :items="categories" key-name="title" @select="filterByCategory") {{ selectedCategory ? selectedCategory.title : 'все'  }}

    addOrg(v-model="dialogAddOrg" :org.sync="org")

    div
      v-layout(row wrap v-if="orgList.length > 0")
        v-flex.px-4(xs4 v-for="(a, index) in orgList" :key="index"  )
          app-card(@click.native="selectItem(a)")
            app-card-header 
              span(v-if="a.organizationCategory != null") {{ a.organizationCategory.title }}
            app-card-body
              app-card-title {{ a.name }}
              app-card-caption.mt-2  Адрес: 
                strong {{ a.address }} 
              app-card-caption.mt-1(v-if="a.city!=''") Город: 
                strong {{ a.city }}
              app-card-caption.mt-1(v-if="a.phone!=''") Телефон: 
                strong {{ a.phone }}
              app-card-caption.mt-1(v-if="a.fax!=''") Факс:
                strong {{ a.fax }}
              app-card-caption.mt-1(v-if="a.email!=''") E-mail: 
                strong {{ a.email }}
              app-card-caption.mt-1(v-if="a.site!=''") Сайт: 
                strong {{ a.site }}
              app-card-caption.mt-1(v-if="a.sendChannel") Тип доставки: 
                strong {{ a.sendChannel.title }}
              app-card-caption.mt-1 Сертификат: 
                 strong(v-if="a.hasCert") установлен
                 strong(v-else) нет


</template>

<script>
import { AppToolbarItemDivider } from '@/components'
import { mapGetters, mapMutations, mapState } from 'vuex';
import addOrg from './components/AddOrg'


export default {
  components: {
    addOrg
  },

  methods: {
    ...mapMutations('organization', [ 'selectCategory']),

    filterByCategory(cat) {
      this.selectCategory(cat)
    },

    selectItem (item) {
      this.$router.push({name: 'OrgTemplate', params: {orgId: item.id}})
//      this.org = item
//      this.dialogAddOrg = true
    },

    addItem () {
      this.org = null
      this.dialogAddOrg = true
    },
  },

  data() {
    return {
      dialogAddOrg: false,
      org: null,
    }
  },


  computed: {
    ...mapState('organization', [ 'selectedCategory']),
    ...mapGetters('organization', ['orgs','isOrgsLoaded','categories','isCategoriesLoaded']),

    fabItems () {
      return [
        AppToolbarItemDivider, 
        { icon:'add', title:'Добавить организацию', action: () => this.dialogAddOrg = true }
      ]
    },

    orgList() {
      let list = (this.selectedCategory == null) ? this.orgs : this.orgs.filter(c => c.organizationCategory!=null && c.organizationCategory.value == this.selectedCategory.value)
      return list
    },

  },
  created() {
    this.$store.dispatch('organization/INIT')
  }
}


</script>

<style scoped>
</style>
